export var ByteRatesUnitId;
(function (ByteRatesUnitId) {
    ByteRatesUnitId["BitsPerSecond"] = "bits/sec";
    ByteRatesUnitId["KilobitsPerSecond"] = "kilobits/sec";
    ByteRatesUnitId["MegabitsPerSecond"] = "megabits/sec";
    ByteRatesUnitId["GigabitsPerSecond"] = "gigabits/sec";
    ByteRatesUnitId["BytesPerSecond"] = "bytes/sec";
    ByteRatesUnitId["KilobytesPerSecond"] = "kilobytes/sec";
    ByteRatesUnitId["MegabytesPerSecond"] = "megabytes/sec";
    ByteRatesUnitId["GigabytesPerSecond"] = "gigabytes/sec";
    // deprecated
    ByteRatesUnitId["bps"] = "bps";
    ByteRatesUnitId["Bps"] = "Bps";
    ByteRatesUnitId["KBps"] = "KBps";
    ByteRatesUnitId["MBps"] = "MBps";
    ByteRatesUnitId["GBps"] = "GBps";
})(ByteRatesUnitId || (ByteRatesUnitId = {}));
export var bitRates = [
    {
        id: ByteRatesUnitId.BitsPerSecond,
        alias: ["bps", "bits/sec(bps)"],
        divisor: 1,
        display: "bps",
    },
    {
        id: ByteRatesUnitId.KilobitsPerSecond,
        alias: ["Kbps", "kilobits/sec(Kbps)"],
        divisor: 1000,
        display: "Kbps",
    },
    {
        id: ByteRatesUnitId.MegabitsPerSecond,
        alias: ["Mbps", "megabits/sec(Mbps)"],
        divisor: 1000 * 1000,
        display: "Mbps",
    },
    {
        id: ByteRatesUnitId.GigabitsPerSecond,
        alias: ["Gbps", "gigabits/sec(Gbps)"],
        divisor: 1000 * 1000 * 1000,
        display: "Gbps",
    },
];
export var byteRates = [
    {
        id: ByteRatesUnitId.BytesPerSecond,
        alias: ["Bps", "bytes/sec(Bps)"],
        divisor: 8,
        display: "Bps",
    },
    {
        id: ByteRatesUnitId.KilobytesPerSecond,
        alias: ["KBps", "kilobytes/sec(KBps)"],
        divisor: 8 * 1000,
        display: "KBps",
    },
    {
        id: ByteRatesUnitId.MegabytesPerSecond,
        alias: ["MBps", "megabytes/sec(MBps)"],
        divisor: 8 * 1000 * 1000,
        display: "MBps",
    },
    {
        id: ByteRatesUnitId.GigabytesPerSecond,
        alias: ["GBps", "gigabytes/sec(GBps)"],
        divisor: 8 * 1000 * 1000 * 1000,
        display: "GBps",
    },
];
export var deprecatedByteRates = [
    {
        id: ByteRatesUnitId.bps,
        divisor: 1,
        display: "bps",
    },
    {
        id: ByteRatesUnitId.Bps,
        divisor: 8,
        display: "Bps",
    },
    {
        id: ByteRatesUnitId.KBps,
        divisor: 8 * 1000,
        display: "KBps",
    },
    {
        id: ByteRatesUnitId.MBps,
        divisor: 8 * 1000 * 1000,
        display: "MBps",
    },
    {
        id: ByteRatesUnitId.GBps,
        divisor: 8 * 1000 * 1000 * 1000,
        display: "GBps",
    },
];
//# sourceMappingURL=byteRates.js.map